import { render } from "./closing.vue?vue&type=template&id=7f5f5862"
import script from "./closing.vue?vue&type=script&lang=js"
export * from "./closing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PC\\Codebase\\390labs\\Coverage\\legacycomposer.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__